/****************************************************************
 * NOTE - WHY IS THE STUDENT FIND CLASSES PAGE THAT LOADS CALLED FINDCLASSESPAGE
 * BUT THIS PAGE IS CALLED STUDENTFINDCLASSES?
 * I should fix this
 * but this URL is loaded from http://localhost:8000/rank/wharton-test/find-classes
 */

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import find from 'lodash/find';
import flattenDeep from 'lodash/flattenDeep';
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import moment from 'moment';

import ModalLeaveWaitlist from './ModalLeaveWaitlist';
import MessageAddDropIsClosed from './MessageAddDropIsClosed';
import StudentSteps from '../common/StudentSteps';
import ModalDropAssignment from '../common/ModalDropAssignment'
import * as runActions from '../../actions/runsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as commonActions from '../../actions/commonActions';
import { Row, Col, Table } from 'react-bootstrap';
import CustomPagination from '../common/CustomPagination';
import LocationRow from './LocationRow';
import DateRangePicker from '../common/DatePicker/DateRangePicker';
import CourseSlug from './CourseSlug'

const defaultSorts = {
  slug: {
    up: false,
    down: false,
    idle: true
  },
  longname: {
    up: false,
    down: false,
    idle: true
  },
  instructor: {
    up: false,
    down: false,
    idle: true
  },
  weight: {
    up: false,
    down: false,
    idle: true
  },
  availability: {
    up: false,
    down: false,
    idle: true
  },
  target_capacity: {
    up: false,
    down: false,
    idle: true
  },
  assignmentToDrop: {},
  waitlistToLeave: {}
}

class StudentFindClassesPage extends React.Component {
  state = {
    dataLoaded: false,
    courses: [],
    startCourses: 0,
    endCourses: 25,
    activeCoursePage: 1,
    expandedCourseId: null,

    ...defaultSorts,

    selected: true,
    coursesToAdd: [],
    preferences: []
  }

  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    // if (!this.props.student.id) {
      this.props.studentActions.getStudent()
    // }
    if (this.props.courses.length === 0) {
      this.props.courseActions.getAllCourses();
    } else {
      this.setState({ dataLoaded: true });
      this.setCoursesToState(this.props.courses);
    }
    if (!this.props.waitlist.isFetched && !this.props.waitlist.isOnFetch) {
      this.props.studentActions.getWaitlist();
    }
    document.addEventListener('keydown', this.checkKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.checkKey);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.courses !== this.props.courses) {
      this.setCoursesToState(nextProps.courses);
      this.setState({ dataLoaded: true });
    }
  }

  setCoursesToState = (courses) => {
    this.setState({ courses });
  }

  handleCourseSearch = (e) => {
    e.preventDefault();

    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.searchCourses(term, this.props.courses);

      this.setState({
        courses: arrUnique,
        startCourses: 0,
        endCourses: 25,
        activeCoursePage: 1
      });
    } else {
      this.setCoursesToState(this.props.courses);
    }
  }

  searchCourses = (term, courses) => {
    let b = courses.filter(course => {
      return (
        course.slug.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.longname.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        course.instructor.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        (course.description && course.description.toLowerCase().indexOf(term.toLowerCase()) != -1)
      );
    });
    return b;
  }

  checkKey = (e) => {
    if (this.refs.courses) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if (this.state.activeCoursePage > 1) {
          this.pageBack();
        }
      } else if (e.keyCode == '39') {
        // right arrow
        if (this.state.activeCoursePage < Math.ceil(this.state.courses.length / 25)) {
          this.pageForward();
        }
      }
    }
  }

  pageBack = () => {
    let newActivePage = this.state.activeCoursePage - 1;
    this.setState({ activeCoursePage: newActivePage });
    if (newActivePage == 1) {
      this.setState({ startCourses: 0, endCourses: 25 });
    } else {
      let start = newActivePage * 25 - 25;
      let end = newActivePage * 25;
      this.setState({ startCourses: start, endCourses: end });
    }
  }

  pageForward = () => {
    let newActivePage = this.state.activeCoursePage + 1;
    this.setState({ activeCoursePage: newActivePage });
    let start = newActivePage * 25 - 25;
    let end = newActivePage * 25;
    this.setState({ startCourses: start, endCourses: end });
  }

  // Ordering
  reorder = (column) => {
    window.console.log('reorder', column)
    
    if (this.state[column].idle) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    } else if (this.state[column].up) {
      this.setState({
        [column]: {
          up: false,
          down: true,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'down');
      this.setState({ courses: a });
    } else if (this.state[column].down) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.courses, column, 'up');
      this.setState({ courses: a });
    }
    let obj = { ...defaultSorts };

    delete obj[column];
    this.setState(obj);

    this.setState({
      startCourses: 0,
      endCourses: 25,
      activeCoursePage: 1
    });
  }

  sortByKeyAndDirection = (array, key, direction) => {
    return array.sort((a, b) => {
      let x = a[key];
      let y = b[key];

      if (key === 'availability') {
        x = this.getAvailablity(a).value
        y = this.getAvailablity(b).value
      }
      if (direction == 'up') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else if (direction == 'down') {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }

  addRemoveLeaveCourse(course) {
    const activeWaitlist = find(this.props.waitlist.data, {course: +course.id});

    if (activeWaitlist) {
      return (
        <span onClick={this.handleLeaveWaitlist.bind(this, {
          ...activeWaitlist,
          course: {
            ...course
          }
        })}>
          Leave
        </span>
      );
    }

    const d = (this.props.student.assignments || []).filter(d => {
      return d.course == course.id;
    });
    if (d[0]) {
      return (
        <span onClick={this.handleDropClass.bind(this, {
          ...d[0],
          slug: course.slug,
          longname: course.longname
        })}>
          Drop
        </span>
      );
    }

    return (
      <Link to={`/rank/${this.props.run.slug}/join-waitlist/${course.id}`}>
        <span onClick={this.handleAddClass.bind(this, course)}>
          Join
        </span>
      </Link>
    );
  }

  handleAddClass = (/*course*/) => {
    // this.props.courseActions.createAdd(course.id)
  }

  handleDropClass(assignment) {
    this.setState({
      assignmentToDrop: assignment
    })
    // this.props.courseActions.dropAssignment(assignmentId)
  }

  handleLeaveWaitlist = (waitlistToLeave) => {
    // this.props.courseActions.deleteWaitlist(id)
    this.setState({
      waitlistToLeave
    })
  }

  handleSelectRange = (from, to) => {
    const { courses } = this.props;
    
    if (from && to) {
      const firstDay = from;
      const lastDay = to;

      const filterCourses = courses.filter((c) => {
        const meetingDates = c.meetings.map((m) => ([m.startdate, m.enddate]));
        const filteredMeetingDates = compact(uniq(flattenDeep(meetingDates)));

        filteredMeetingDates.sort((a, b) => new Date(a) - new Date(b));
        
        const minDate = filteredMeetingDates[0];
        const maxDate = filteredMeetingDates[filteredMeetingDates.length - 1];

        if (
          moment(firstDay).isBetween(moment(minDate), moment(maxDate), null, '[]') ||
          moment(lastDay).isBetween(moment(minDate), moment(maxDate), null, '[]')
        ) {
          return true;
        }

        return false;
      });

      this.setState({
        courses: filterCourses,
        startCourses: 0,
        endCourses: 25,
        activeCoursePage: 1
      });
      
    } else {
      this.setCoursesToState(this.props.courses);
    }
  }

  setRowClassname(course) {
    const activeWaitlist = find(this.props.waitlist.data, {course: +course.id});
    const d = (this.props.student.assignments || []).filter(d => {
      return d.course == course.id;
    });

    if (activeWaitlist) {
      return 'on-waitlist';
    }

    if (d[0]) {
      return 'on-class';
    }

    return '';
  }

  mayRankTheSelection() {
    if (this.props.courses.length != 0) {
      let weightSum = 0;
      this.state.coursesToAdd.map(c => {
        weightSum += c.weight;
      });

      this.props.student.assignments.map(p => {
        let course = commonActions.getCourseObjById(p.course, this.props.courses);
        if (course.id) {
          weightSum += course.weight;
        }
      });
      return weightSum < 2 * this.props.student.target_course_units;
    } else return true;
  }

  renderDescription = (course, expandedCourseId) => {
    if (course.description && expandedCourseId === course.id) {
      return (
        <tr className="class-desc">
          <td colSpan="8">
            <p>{course.description}</p>
          </td>
        </tr>
      );
    }
    return null;
  };

  changeExpandedCourseId = id => {
    const expandedCourseId = this.state.expandedCourseId != id ? id : null;
    this.setState({ expandedCourseId });
  };

  getAvailablity(course) {
    const { waitlist } = this.props
    const activeWaitlist = find(waitlist.data, {course: +course.id});

    const isOnWaitlist = activeWaitlist && activeWaitlist.waitlist_position !== null;
    const isOnPending = activeWaitlist && activeWaitlist.waitlist_position === null;
    const isAssigned = !!find(this.props.student.assignments, { course: course.id })
    const availableSeats = course.target_capacity - course.assigned_students;

    if (isOnPending) {
      return {
        text: 'Pending',
        value: 0
      };
    }
    if (isOnWaitlist) {
      return {
        text: activeWaitlist.waitlist_position <= 20
          ? `Waitlist position: ${activeWaitlist.waitlist_position} of ${course.waitlisted_students} students`
          : 'On the Waitlist',
        value: 0
      };
    }

    if (isAssigned) {
      return {
        text: 'Assigned',
        value: 0
      }
    }

    if (availableSeats >= 1) {
      return {
        text: `${availableSeats} ${ availableSeats === 1 ? 'Seat' : 'Seats'} Available`,
        value: availableSeats
      }
    }

    if (availableSeats <= 0) {
      return {
        text: `${course.waitlisted_students} on Waitlist`,
        value: 0
      }
    }
  }

  getMinDateAndMaxDateOfClasses = () => {
    const { courses } = this.props;

    const courseMeetingDates = courses.reduce((prev, curr) => {
      const courseDates = curr.meetings.map((m) => ([m.startdate, m.enddate]));
      return [ ...prev, ...flattenDeep(courseDates)];
    }, []);

    courseMeetingDates.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

    const meetingDates = compact(uniq(courseMeetingDates));

    return {
      minDate: meetingDates[0],
      maxDate: meetingDates[meetingDates.length - 1]
    };
  }

  render() {
    const ENABLE_NEW_WAITLIST_CODE = true
    const { pending_request_count} = this.props.student;
    const { assignment_complete, add_drop_open, primary_contact, max_waitlist_requests } = this.props.run;
    const { slug, longname, instructor, weight, availability } = this.state;
    const { minDate, maxDate } = this.getMinDateAndMaxDateOfClasses();
    const isClosed = (add_drop_open === false && assignment_complete);
    // this is null, by default, I believe, instead of a number
    // but this will block people who have too many waitlists (2021)
    // When we refactor, we can break up this render function to be
    // cleaner
    // console.debug(`[max_waitlist_requests] - ${JSON.stringify(max_waitlist_requests, null, 2)}`)
    // console.debug(`[pending_request_count] - ${JSON.stringify(pending_request_count, null, 2)}`)
    // console.debug(`[ENABLE_NEW_WAITLIST_CODE] - ${JSON.stringify(ENABLE_NEW_WAITLIST_CODE, null, 2)}`)
    if (ENABLE_NEW_WAITLIST_CODE && max_waitlist_requests) {
      if (pending_request_count >= max_waitlist_requests) {
        return (
        <div>
          <Row>
            <Col md={12}>
              <StudentSteps active={2} isAssignmentCompleted={true} />
              You have reached the maximum number of allowable waitlist requests. Please remove requests if you would like to add others.
            </Col>
          </Row>
        </div>
        )
      }
    }
    
    return (
      <div>
        <Row>
          <Col md={12}>
            {/* <div className="page-title">Classes</div> */}
            <StudentSteps active={2} isAssignmentCompleted={true} />

            {!assignment_complete ? (
              this.props.run.add_drop_not_open_text != null ? (
                <Row>
                  <Col md={9}>
                    <p className="mb-2 lead" dangerouslySetInnerHTML={{
                      __html: this.props.run.add_drop_not_open_text
                        .replace('[[[primary_contact_email]]]',
                          `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)
                    }}>
                    </p>
                  </Col>
                </Row>
              ) : (
                  ''
              )) :
              (this.props.run.additional_find_classes_add_drop != null ? (
                <Row>
                  <Col md={9}>
                    <p className="mb-2 lead" dangerouslySetInnerHTML={{__html: this.props.run.additional_find_classes_add_drop
                      .replace('[[[primary_contact_email]]]',
                        `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)}}>
                    </p>
                  </Col>
                </Row>
              ) : (
                  ''
                ))}
            { isClosed ? (
              <MessageAddDropIsClosed email={primary_contact} />
            ) : (
              <Row>
                <Col md={9}>
                  <div className="form-group search">
                    <span className="fa fa-search" />
                    <input
                      name="conflictSearchInput"
                      onChange={this.handleCourseSearch}
                      type="text"
                      className="form-control search"
                      placeholder="Type name, description or instructor..."
                    />
                    <span className="input-description">Type name, description or instructor to filter courses</span>
                  </div>
                </Col>
                {this.props.courses.length > 0 && (
                  <Col md={3}>
                    <DateRangePicker
                      handleSelectRange={this.handleSelectRange}
                      inputLabel="Filter classes by date range"
                      showClearButton
                      inputClassNames="week-picker-auto-width"
                      minDate={minDate}
                      maxDate={maxDate}
                    />
                  </Col>
                )}
              </Row>
            )}
          </Col>
        </Row>
        { isClosed ? null : (
          <Row ref="courses" className="height480">
            {this.state.dataLoaded && this.props.waitlist.isFetched ? (
              <Col md={12}>
                {this.props.courses.length > 0 ? (
                  <div className="c-table classes-table">
                    <Table condensed hover>
                      <thead>
                        <tr>
                          <th
                            className="name"
                            onClick={() => {
                              this.reorder('slug');
                            }}
                          >
                            <span>
                              Name {slug.up ? <i className="fa fa-sort-up" /> : null}
                              {slug.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {slug.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                          <th
                            onClick={() => {
                              this.reorder('longname');
                            }}
                            className="max-width-300"
                          >
                            <span>
                              Description {longname.up ? <i className="fa fa-sort-up" /> : null}
                              {longname.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {longname.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                          <th
                            onClick={() => {
                              this.reorder('instructor');
                            }}
                          >
                            <span>
                              Instructor {instructor.up ? <i className="fa fa-sort-up" /> : null}
                              {instructor.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {instructor.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                          <th>Location/Time</th>
                          <th
                            onClick={() => {
                              this.reorder('weight');
                            }}
                          >
                            <span>
                              Credits {weight.up ? <i className="fa fa-sort-up" /> : null}
                              {weight.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {weight.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                          <th
                            onClick={() => {
                              this.reorder('availability');
                            }}
                          >
                            <span>
                              Availability {availability.up ? <i className="fa fa-sort-up" /> : null}
                              {availability.down ? <i className="fa fa-sort-down" /> : null}{' '}
                              {availability.idle ? <i className="fa fa-sort" /> : null}
                            </span>
                          </th>
                          <th className="text-center">
                            <span>Action</span>
                          </th>
                          <th />
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.courses
                          .filter((c) => !c.is_locked)
                          .slice(this.state.startCourses, this.state.endCourses)
                          .map((course, index) => {
                          return [
                            <tr key={index} className={`${this.setRowClassname(course)}`}>
                              <td className="find-class-name"><CourseSlug course={course} /></td>
                              <td className="class-desc max-width-300">
                                <p>{course.longname}</p>
                                {course.description && (
                                  <button className="plain-button" onClick={() => this.changeExpandedCourseId(course.id)}>
                                    {this.state.expandedCourseId === course.id
                                      ? 'Hide Extended Description'
                                      : 'Show Extended Description'}
                                  </button>
                                )}
                              </td>
                              <td className="class-desc">{course.instructor}</td>
                              <td className="class-desc">
                                <LocationRow locations={commonActions.getCourseLocations(course)} />
                              </td>
                              <td className="class-desc">{course.weight}</td>
                              <td className="class-desc w-200">{this.getAvailablity(course).text}</td>
                              <td className="class-edit">{ this.addRemoveLeaveCourse(course) }</td>
                            </tr>,
                            this.renderDescription(course, this.state.expandedCourseId)
                          ];
                        })}
                      </tbody>
                    </Table>
                    <CustomPagination
                      activePage={this.state.activeCoursePage}
                      onBack={this.pageBack}
                      onForward={this.pageForward}
                      listLength={Math.ceil(this.state.courses.filter((c) => !c.is_locked).length / 25)}

                    />
                  </div>
                ) : (
                  <div className="text-center">No Classes</div>
                )}
              </Col>
            ) : (
              <div className="spinner-box">
                <Spinner spinnerName="three-bounce" className="mt-4" />
              </div>
            )
          }
          </Row>
        )}
        <ModalDropAssignment
          assignment={this.state.assignmentToDrop}
          onClose={this.handleModalDropAssignmentClose}
          />
        <ModalLeaveWaitlist
          position={this.state.waitlistToLeave}
          onClose={this.handleModalLeaveWaitlistClose}
          />
      </div>
    );
  }

  handleModalDropAssignmentClose = () => {
    this.setState({
      assignmentToDrop: {}
    });
  }

  handleModalLeaveWaitlistClose = () => {
    this.setState({
      waitlistToLeave: {}
    });
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    waitlist: state.waitlist
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentFindClassesPage);



// WEBPACK FOOTER //
// ./src/components/rank/StudentFindClassesPage.js